import { useTranslation } from 'next-i18next';
import React, { useState } from 'react';
import { ComponentSettingsInterface, MarginComponentInterface } from '../../../../../interfaces/pagebuilder';
import { useSelector } from '../../../../../reduxToolkit/typedRedux';
import SidebarToolbar from '../../SidebarToolbar';
import SettingsTemplate from '../SettingsTemplate';
import MarginSettingsTable from './MarginSettingsTable';
import MarginStyling from './MarginStyling';

const MarginSettings = ({ onClose, component, onChange }: ComponentSettingsInterface<MarginComponentInterface>) => {
  const showVisibilitySettings = useSelector((state) => state.common.showVisibilitySettings);
  const [selectedTab, setSelectedTab] = useState<number>(showVisibilitySettings ? 2 : 0);

  const { t } = useTranslation();

  return (
    <>
      <SidebarToolbar name={t('pagebuilder:margin')} onClose={onClose} value={selectedTab} onChange={(e, newValue: number) => setSelectedTab(newValue)} />

      <SettingsTemplate
        selectedTab={selectedTab}
        component={component}
        hasDefaultPadding={false}
        onChange={onChange}
        StylingChildren={<MarginStyling component={component} onChange={onChange} />}>
        <MarginSettingsTable onChange={onChange} component={component} />
      </SettingsTemplate>
    </>
  );
};
export default MarginSettings;
